import React from "react";
import styles from "./styles.module.scss";
import coachnow_logo from "app/images/Logo_dark.svg";
import pro_badge from "app/images/pro_dark_bg.svg";
import orange_bg_check from "app/images/orange_bg_checkmark.svg";
import { useTranslation } from "react-i18next";
import { PromoDiscount } from "app/models/PromoOffer";
import { Currency, formatPrice } from "app/utils/currency";
import DiscountedPrice from "app/components/DiscountedPrice";
import TrialPriceLine from "app/components/TrialPriceLine";
import { ProPlanCode } from "app/utils/planPricing";
import { usePlanPricing } from "app/hooks/usePlanPricing";

interface IProps {
  planCode: ProPlanCode;
  currency?: Currency;
  loading?: boolean;
  // The resolved offer's discount (from the backend), or null/undefined.
  discount?: PromoDiscount | null;
  // The plan's live base price (cents) for the currency, from the backend
  // resolution (matches the marketing table by Stripe Price nickname).
  baseAmount?: number;
  // Direct purchase: no free-trial headline, the price itself leads.
  purchase?: boolean;
  // The paywall's copy (from its GrowthBook flag, defaulting to today's).
  description: string;
  trialHeadline: string;
}

const PriceCard = ({
  planCode,
  currency = "usd",
  loading,
  discount,
  baseAmount,
  purchase = false,
  description,
  trialHeadline,
}: IProps) => {
  const { t } = useTranslation();

  const isYearly = planCode === "coachpro+yearly";
  const pricing = usePlanPricing({ baseAmount, discount, isYearly });
  const { base, discountedAmount, isDiscounted, interval, billing } = pricing;

  return (
    <div className={styles.pricing_card}>
      <img
        src={orange_bg_check}
        alt="checked plan"
        className={styles.plan_checkmark}
      />
      <div className={styles.header}>
        <div className={styles.top_side_content}>
          <div className={styles.header_wrapper}>
            <div className={styles.header_logo_wrapper}>
              <img
                src={coachnow_logo}
                alt="CoachNow Logo"
                className={styles.site_logo}
              />
              <img
                src={pro_badge}
                alt="Pro Logo"
                className={styles.pro_badge}
              />
            </div>
          </div>
          <p>{description}</p>
        </div>

        <div>
          <h3 className={styles.content_title}>
            {loading
              ? t("Applying your offer…")
              : !purchase
              ? trialHeadline
              : isDiscounted
              ? (
                <DiscountedPrice
                  discounted={discountedAmount}
                  original={base}
                  currency={currency}
                  interval={interval}
                />
              )
              : t("{{price}} per {{interval}}", {
                  price: formatPrice(discountedAmount, currency),
                  interval,
                })}
          </h3>
          <p className={styles.content_description}>
            {loading ? null : purchase ? (
              billing
            ) : (
              <TrialPriceLine pricing={pricing} currency={currency} />
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PriceCard;
